"use client";

import * as React from "react";
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { ContentfulLivePreview } from "@contentful/live-preview";

import { RichTextEntry } from "../richText/generic";
import { HeroCorpoPage } from "./heroCorpoPage";
// import { IProfile } from "@/types/profile";
import { IPage } from "@/types/page";
import { PostSummary } from "../richText/summary";
import { IProfile } from "@/types/profile";
import clsx from "clsx";
import { CorporatePageFooterNav } from "../menu/corporateNav";

export const PageSingle = ({
  entry,
  siblings,
  profiles,
}: // profiles,
{
  entry: IPage;
  siblings: IPage[];
  profiles?: IProfile[];
}) => {
  // const data = useContentfulLiveUpdates(entry, { locale: "en" });
  const data = useContentfulLiveUpdates(entry, { locale: "fr" });

  if (!data || !entry) return null;
  // console.log("profiles", profiles);
  return (
    <ContentfulLivePreviewProvider
      locale="fr"
      enableInspectorMode={true}
      enableLiveUpdates={true}
      debugMode={true}
    >
      <div className="xl:pl-14 bg-line-pattern bg-[length:600px_600px] bg-repeat bg-fixed">
        <div className="xl:border-l xl:border-l-gray-200 ">
          <HeroCorpoPage entry={data} siblings={siblings} />
          <div className="bg-white xl:-mt-12">
            <div className="grid xl:grid-cols-12">
              {entry.singleColumnLayout === false ||
              entry.singleColumnLayout === null ? (
                <div className="xl:col-span-4 order-2 xl:order-1 hidden xl:block">
                  <div className="sticky top-10">
                    {data.sidebarBody?.json && (
                      <div
                        className="xl:px-16 space-y-10 border-b border-gray-100  pt-10 xl-pt-0 pb-12"
                        {...ContentfulLivePreview.getProps({
                          entryId: entry.sys.id,
                          fieldId: "sidebarBody",
                        })}
                      >
                        <RichTextEntry
                          richTextDocument={data.sidebarBody?.json}
                          links={data.sidebarBody.links}
                          profiles={profiles}
                        />
                      </div>
                    )}
                    <div className="xl:px-16 space-y-10 border-t xl:border-t-0 pt-10 xl-pt-0 pb-12">
                      <PostSummary richTextDocument={data.body.json} />
                    </div>
                  </div>
                </div>
              ) : null}
              <div
                className={clsx(
                  " px-6 py-8 xl:px-16 order-1 xl:order-2 xl:py-12",
                  entry.singleColumnLayout === true
                    ? `xl:col-span-12 border-t xl:py-20`
                    : `xl:col-span-8 xl:border-l`
                )}
              >
                {data.body?.json && (
                  <div
                    {...ContentfulLivePreview.getProps({
                      entryId: entry.sys.id,
                      fieldId: "body",
                    })}
                  >
                    <RichTextEntry
                      richTextDocument={data.body?.json}
                      links={data.body.links}
                      profiles={profiles}
                      keyIndicators={entry.keyIndicators?.list ?? []}
                    />
                  </div>
                )}

                <div className="xl:block mt-20 py-20 border-t w-[calc(100%+8rem)] -ml-16 px-16 hidden">
                  <CorporatePageFooterNav
                    pages={siblings}
                    currentPageId={entry.sys.id}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentfulLivePreviewProvider>
  );
};
